import { render } from "./SortControl.vue?vue&type=template&id=e4ce4b18&scoped=true"
import script from "./SortControl.vue?vue&type=script&lang=js"
export * from "./SortControl.vue?vue&type=script&lang=js"

import "./SortControl.vue?vue&type=style&index=0&id=e4ce4b18&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ce4b18"]])

export default __exports__